import React from 'react'
import styled from 'styled-components'

const Text = styled.h4`
  color: #f2f2f2;
  font-size: 0.9rem;
  margin-top: 1rem;
  text-align: center;
`

function NotFound() {
  return <Text>Data currently unavailable.</Text>
}

export default NotFound
